const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async queryPartsSalesList({ rootState }, params = {}) {
      const data = await rootState.http("/report/partsSalesReport/pc", params);
      return data;
    },
    async queryReceiptReportList({ rootState }, params = {}) {
      const data = await rootState.http("/receipt/list/byReceiptType", params);
      return data;
    },
    async queryReceiptReportDetail({ rootState }, params = {}) {
      const data = await rootState.http("/receipt/report/byReceiptType", params);
      return data;
    }
  }
};

export default store;
